<ngx-skeleton-loader animation="pulse" [count]="linesNum" [theme]="{
    height: '60px',
    'margin-bottom': '0px',
    'margin-top': '15px'
  }"></ngx-skeleton-loader>